import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { FilterBannerService } from './filter-banner.service';

@Component({
  selector: 'app-filter-banner',
  standalone: false,
  templateUrl: './filter-banner.component.html',
  styleUrl: './filter-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('slide', [
      transition(':enter', [
        style({ transform: 'translateX(120%)' }),
        animate('300ms ease-out', style({ transform: 'translateX(0)' })),
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ transform: 'translateX(120%)' })),
      ]),
    ]),
  ],
})
export class FilterBannerComponent {
  readonly banner = inject(FilterBannerService).banner;
}
